module.exports = __webpack_public_path__ + "img/banner_sp.c4173d9d.jpg";